/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Languagerequirementsen_Label3Inputs */

const en_job_form_languagerequirementsen_label3 = /** @type {(inputs: Job_Form_Languagerequirementsen_Label3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English Language Skills`)
};

const de_job_form_languagerequirementsen_label3 = /** @type {(inputs: Job_Form_Languagerequirementsen_Label3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachkenntnisse Englisch`)
};

/**
* | output |
* | --- |
* | "English Language Skills" |
*
* @param {Job_Form_Languagerequirementsen_Label3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_languagerequirementsen_label3 = /** @type {((inputs?: Job_Form_Languagerequirementsen_Label3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Languagerequirementsen_Label3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_languagerequirementsen_label3(inputs)
	return en_job_form_languagerequirementsen_label3(inputs)
});
export { job_form_languagerequirementsen_label3 as "job_form_languageRequirementsEN_label" }